import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { SpecificSearchToneDto } from '../../../dto/specificsearchtone/specificsearchtonedto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface SpecificSearchToneResponse extends MiddlewareAPIResponse
{
    getSpecificSearchToneDto(): SpecificSearchToneDto;
}

export class SpecificSearchToneResponseDtoImpl extends MiddlewareDtoImpl implements SpecificSearchToneResponse
{
    private specificSearchToneRespnseDto : SpecificSearchToneDto;

    getSpecificSearchToneDto(): SpecificSearchToneDto
    {
        return this.specificSearchToneRespnseDto;
    }
    setSpecificSearchToneDto(specificSearchToneRespnseDto: SpecificSearchToneDto)
    {
        this.specificSearchToneRespnseDto = specificSearchToneRespnseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/specificsearchtone/specificsearchtoneresponse.tsx